import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFunding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M10.767 7.787a1.75 1.75 0 0 1 2.475 0l2.97 2.97a1.75 1.75 0 0 1 0 2.475l-2.97 2.97a1.75 1.75 0 0 1-2.475 0l-2.97-2.97a1.75 1.75 0 0 1 0-2.475l2.97-2.97Zm1.414 1.06a.25.25 0 0 0-.354 0l-2.97 2.97a.25.25 0 0 0 0 .354l2.97 2.97a.25.25 0 0 0 .354 0l2.97-2.97a.25.25 0 0 0 0-.354l-2.97-2.97Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorFunding;
